// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboardSideMenu{
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.dashboardSideMenu_group{
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding-bottom: 11px;
    margin-bottom: 11px;
    /*border-bottom: 1px solid rgba(152, 159, 201, 0.12);*/
}

.dashboardSideMenu_button{
    display: flex;
    align-items: center;
    gap: 22px;

    min-width: calc(111px + 12px * 2);
    font-weight: 400;
    font-size: calc(14px * var(--fontScaler));
    line-height: 24px;
    
    color: #000000;
    padding: 0 12px;
}

.dashboardSideMenu_button::before{
    content: "";
    width: 22px;
    height: 22px;

    background-color: #0000;
    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;
}

.dashboardSideMenu_button:hover{
    background-color: #F3F6FF;
}`, "",{"version":3,"sources":["webpack://./src/pages/dashboardPage/components/sideMenu/SideMenu.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,oBAAoB;IACpB,mBAAmB;IACnB,sDAAsD;AAC1D;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;;IAET,iCAAiC;IACjC,gBAAgB;IAChB,yCAAyC;IACzC,iBAAiB;;IAEjB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,YAAY;;IAEZ,uBAAuB;IACvB,2BAA2B;IAC3B,wBAAwB;IACxB,4BAA4B;AAChC;;AAEA;IACI,yBAAyB;AAC7B","sourcesContent":[".dashboardSideMenu{\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n}\n\n.dashboardSideMenu_group{\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n    padding-bottom: 11px;\n    margin-bottom: 11px;\n    /*border-bottom: 1px solid rgba(152, 159, 201, 0.12);*/\n}\n\n.dashboardSideMenu_button{\n    display: flex;\n    align-items: center;\n    gap: 22px;\n\n    min-width: calc(111px + 12px * 2);\n    font-weight: 400;\n    font-size: calc(14px * var(--fontScaler));\n    line-height: 24px;\n    \n    color: #000000;\n    padding: 0 12px;\n}\n\n.dashboardSideMenu_button::before{\n    content: \"\";\n    width: 22px;\n    height: 22px;\n\n    background-color: #0000;\n    background-position: center;\n    background-size: contain;\n    background-repeat: no-repeat;\n}\n\n.dashboardSideMenu_button:hover{\n    background-color: #F3F6FF;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
